import { on } from "@ngrx/store";
import { RoleAddedAction, RoleDeletedAction, RoleLoadedAllAction, RolePermissionAddedAction, RolePermissionRemovedAction, RoleUpdatedAction } from "./role.actions";

export const roleReducer = [
  on(RoleLoadedAllAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: action.situazioneRuoli });
  }),
  on(RoleDeletedAction, (state: any, action) => {
    return Object.assign({}, state, {
      situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli.filter(p => p.id_ruolo !== +action.id),
        permessi: state.situazioneRuoli.permessi
      },
      users: state.users.map(element => element.ruolo === +action.id ? { ...element, ruolo: null } : element)
    });
  }),
  on(RoleAddedAction, (state: any, action) => {
    return Object.assign({}, state, {
      situazioneRuoli: {
        ruoli: [...state.situazioneRuoli.ruoli, action.ruolo],
        permessi: state.situazioneRuoli.permessi
      }});
  }),
  on(RolePermissionAddedAction, (state: any, action) => {
    return Object.assign({}, state, {
      situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli.map(role => role.id_ruolo === action.permissionToRole.id_ruolo ? { ...role, permessi: [...role.permessi, action.permissionToRole.permessi[0]] } : role),
        permessi: state.situazioneRuoli.permessi
      }});
  }),
  on(RolePermissionRemovedAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli.map(role => role.id_ruolo === action.permissionFromRole.id_ruolo ? { ...role, permessi: role.permessi.filter(permesso => permesso !== action.permissionFromRole.permessi[0]) } : role),
        permessi: state.situazioneRuoli.permessi
      }});
  }),
  on(RoleUpdatedAction, (state: any, action) => {
    return Object.assign({}, state, { situazioneRuoli: {
        ruoli: state.situazioneRuoli.ruoli.map(element => element.id_ruolo === action.role.id_ruolo ? { ...element, id_ruolo: action.role.id_ruolo, ruolo: action.role.ruolo } : element),
        permessi: state.situazioneRuoli.permessi
      }});
  })
];
